(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    console.log("loaded");
    let list = document.querySelectorAll(".collection .featured-collection-section");

    list.forEach(
      function(el) {
        new MiniBar(el, {
          alwaysShowBars: true
        });
        const listItems = el.querySelectorAll(".card-wrapper .media");

        listItems.forEach(function(elem) {
          new Flickity( elem, {
            cellAlign: 'left',
            cellSelector: 'a',
            contain: true,
            wrapAround: true,
            prevNextButtons:true,
            arrowShape: 'M24.42,99.16a2.84,2.84,0,0,0,2,.84,2.74,2.74,0,0,0,2-.84L75.58,52a2.81,2.81,0,0,0,0-4L28.42.83a2.83,2.83,0,1,0-4,4L69.58,50,24.42,95.16A2.82,2.82,0,0,0,24.42,99.16Z'
          });
        })
      }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('#FooterCountryList'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget !== null && (!event.relatedTarget.classList.contains('link') && !event.relatedTarget.classList.contains('disclosure__item')) || (event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.announcementBar = document.getElementById("shopify-section-announcement-bar");
        this.headerBounds = {};
        this.currentScrollTop = 0;

        this.onScrollHandler = this.onScroll.bind(this);

        window.addEventListener('scroll', this.onScrollHandler, false);

        const mainMenuLinks = this.header.querySelectorAll(".header__menu-item--control");
        var mainMenuLinksArr = [...mainMenuLinks]; // converts NodeList to Array
        mainMenuLinksArr.forEach(link => {
          link.addEventListener("mouseover", function( event ) {
            mainMenuLinksArr.forEach(link => {
              link.classList.remove("is-selected");
            });
            this.classList.add("is-selected");
          });          
        });


        this.createObserver();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop <= this.headerBounds.top) {
            requestAnimationFrame(this.reset.bind(this));
        }


        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.announcementBar.classList.remove("sticky")
            this.header.classList.remove("move-down");
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.announcementBar.classList.add("sticky");
            this.header.classList.add("move-down");
        } else if (scrollTop <= this.headerBounds.top) {
            this.announcementBar.classList.remove("sticky");
            this.header.classList.remove("move-down");
        }


        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    reveal() {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
    }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const listItems = document.querySelectorAll("#main-collection-product-grid .card__inner .media");
    console.log(listItems);

    listItems.forEach(function(elem) {
      new Flickity( elem, {
        cellAlign: 'left',
        cellSelector: 'a',
        contain: true,
        wrapAround: true,
        prevNextButtons:true,
        arrowShape: 'M24.42,99.16a2.84,2.84,0,0,0,2,.84,2.74,2.74,0,0,0,2-.84L75.58,52a2.81,2.81,0,0,0,0-4L28.42.83a2.83,2.83,0,1,0-4,4L69.58,50,24.42,95.16A2.82,2.82,0,0,0,24.42,99.16Z'
      });
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {

  if (window.matchMedia('(min-width: 769px)').matches) {
    var selects = document.querySelectorAll('.select__select');

    [].forEach.call(selects, function(select) {
        NiceSelect.bind(select);
    });
  }

  if (window.matchMedia('(min-width: 769px)').matches) {
    var tooltip = new Tooltip({
      theme: "dark", // Selects one of the pre-defined tooltip styles - light or dark.
      distance: 10,    // Specifies the distance in pixels from trigger to tooltip.
      delay: 0        // Specifies how long the tooltip remains visible (in ms) after the mouse leaves the trigger.
    });
  }
  else {
    var tooltip = new Tooltip({
      theme: "dark", // Selects one of the pre-defined tooltip styles - light or dark.
      distance: 10,    // Specifies the distance in pixels from trigger to tooltip.
      delay: 0        // Specifies how long the tooltip remains visible (in ms) after the mouse leaves the trigger.
    });    
  }

}, false);

class ProductModal extends ModalDialog {
    constructor() {
        super();
    }

    hide() {
        super.hide();
        window.pauseAllMedia();
    }

    show(opener) {
        super.show(opener);
        this.showActiveMedia();
    }

    showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${
            this.openedBy.getAttribute("data-media-id")
        }"])`).forEach((element) => {
            element.classList.remove('active');
        })
        const activeMedia = this.querySelector(`[data-media-id="${
            this.openedBy.getAttribute("data-media-id")
        }"]`);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template') ?. content ?. querySelector('.js-youtube')) 
            activeMedia.loadContent();
        

    }
}

customElements.define('product-modal', ProductModal);
                              
let slideshow;

function handleResize() {
		const mobileMq = window.matchMedia( "(max-width: 750px)" );
        const desktopMq = window.matchMedia( "(min-width: 1080px)" );
		if (mobileMq.matches) {

            var elem = document.querySelector('.product__media-list');
            slideshow = new Flickity( elem, {
              cellAlign: 'left',
              contain: true,
		      wrapAround: true,
			  prevNextButtons:false,
            });

			var tapArea, startX ;
            tapArea = document.querySelectorAll('.product__media-list');
            startX = 0;
            for (var item of tapArea) {
                item.ontouchstart = function(e) {
                    startX = e.touches[0].clientX;
                };
                item.ontouchmove = function(e) {
                    if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
                        e.preventDefault();
                    } 
                };
            };


        }
		else {
            if (slideshow !== undefined) {
  			  slideshow.destroy();
            }
		}
        // equalize height for columns if text column in higher than image
        if (desktopMq.matches) {
          const textWrapper = document.querySelector(".product__info-wrapper");
          const textWrapperHeight = textWrapper.getBoundingClientRect().height;
          const mediaWrapper = document.querySelector(".product__media-wrapper");
          const mediaWrapperHeight = mediaWrapper.getBoundingClientRect().height;
          if (mediaWrapperHeight < textWrapperHeight) {
            mediaWrapper.setAttribute("style", `max-height:none;height:calc(${textWrapperHeight}px - 2rem)`);
          }
        }
}

document.addEventListener( 'DOMContentLoaded', function () {
	handleResize(); 
});

window.onresize = handleResize;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            let list = document.querySelectorAll(".product-recommendations .featured-collection-section");

            list.forEach(
              function(el) {
                new MiniBar(el, {
                  alwaysShowBars: true
                });
                const listItems = el.querySelectorAll(".card-wrapper .media");

                listItems.forEach(function(elem) {
                  new Flickity( elem, {
                    cellAlign: 'left',
                    cellSelector: 'a',
                    contain: true,
        		    wrapAround: true,
        			prevNextButtons:true,
                    arrowShape: 'M24.42,99.16a2.84,2.84,0,0,0,2,.84,2.74,2.74,0,0,0,2-.84L75.58,52a2.81,2.81,0,0,0,0-4L28.42.83a2.83,2.83,0,1,0-4,4L69.58,50,24.42,95.16A2.82,2.82,0,0,0,24.42,99.16Z'
                  });
                })
              }
            );
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selected-products"] && !window.DesignMode) return;
  try {
    

  
  function handleResize() {

      let list = document.querySelectorAll(".selected-products");
      const mobileMq = window.matchMedia( "(max-width: 750px)" );
      const desktopMq = window.matchMedia( "(min-width: 1080px)" );


        list.forEach(function(elem) {
          const slider = new Flickity( elem, {
            cellAlign: 'left',
            cellSelector: '.slider__slide',
            contain: true,
            wrapAround: true,
            prevNextButtons:true,
            freeScroll: true,
            pageDots: false,
            freeScrollFriction: 0.02,
            arrowShape: 'M24.42,99.16a2.84,2.84,0,0,0,2,.84,2.74,2.74,0,0,0,2-.84L75.58,52a2.81,2.81,0,0,0,0-4L28.42.83a2.83,2.83,0,1,0-4,4L69.58,50,24.42,95.16A2.82,2.82,0,0,0,24.42,99.16Z'
          });
        });
  }
  
  document.addEventListener( 'DOMContentLoaded', function () {
  	handleResize(); 
  });
  
  window.onresize = handleResize;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoomable-images"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    let list = document.querySelectorAll(".zoomable-images__section");

    list.forEach(
      function(el) {
        new MiniBar(el, {
          alwaysShowBars: false
        });
      }
    );
});


  } catch(e) { console.error(e); }
})();
})();
